// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipWrapper__qVlMSEjThz{display:inline-block}`, "",{"version":3,"sources":["webpack://./src/assets/components/teamPage/components/teamChannelIconsList/teamChannelIconsList.module.scss"],"names":[],"mappings":"AAAA,4BACE,oBAAA","sourcesContent":[".tooltipWrapper {\n  display: inline-block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipWrapper": `tooltipWrapper__qVlMSEjThz`
};
export default ___CSS_LOADER_EXPORT___;
